import React from 'react'
import { useApiListNodeGroup } from '../../../../../../api-new/state/content'
import { Menu, MenuAdd, MenuRemove } from '../../../../../../shared/menu/menu'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconGroup } from '../../../../../../shared/icon/icon'
import { ModalDialog, useModalActionID } from '../../../../../../shared/component/modal-dialog'
import { PermissionNodeGroupModal } from '../../../../../../shared/permission-modal/permission-node-group-module'
import { useRoleOrgNodeGroup } from '../../../../../../role/hook/role-org'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnText, ColumnMenu } from '../../../../../../shared/table-builder/table-columns'
import { ButtonPrimary, ButtonSecondary } from '../../../../../../shared/legacy/button'
import { useLoginSysAdmin } from '../../../../../../role/hook/login-sys-admin'

export const PermissionNodeGroup = ({ nodeID }) => {
  const apiListNodeGroup = useApiListNodeGroup()

  const roleOrgNodeGroup = useRoleOrgNodeGroup()
  const loginSysAdmin = useLoginSysAdmin()

  const [target, show, hide] = useModalActionID()
  const [targetConfirm, showConfirm, hideConfirm] = useModalActionID()

  const handleReady = () => apiListNodeGroup.get(`${nodeID}/node`)
  const handleDestroyed = () => apiListNodeGroup.init()

  const handleAddShow = () => show()
  const handleClose = () => hide()

  const handleClosed = async () => apiListNodeGroup.get(`${nodeID}/node`)

  const handleDelete = async item => {
    await apiListNodeGroup.delete(`${nodeID}/${item.groupID}`)
    await apiListNodeGroup.get(`${nodeID}/node`)
  }

  // const handleDeleteAll = async () => {
  //   await apiListNodeGroup.delete(`node/${nodeID}`)
  //   await apiListNodeGroup.get(`${nodeID}/node`)
  // }

  const handleDeleteDescendents = async () => showConfirm()
  const handleDeleteCancel = () => hideConfirm()

  const handleDeleteConfirm = async () => {
    await apiListNodeGroup.delete(`node-descendents/${nodeID}`)
    await apiListNodeGroup.get(`${nodeID}/node`)
    hideConfirm()
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add" onClick={handleAddShow} show={roleOrgNodeGroup.accessCreate} />
      {/* <MenuRemove text="remove all" onClick={handleDeleteAll} show={roleOrgNodeUser.accessDelete} /> */}
      <MenuRemove text="Remove All Cascade" onClick={handleDeleteDescendents} show={loginSysAdmin} />
    </Menu>

  return (
    <React.Fragment>
      <ModalDialog target={targetConfirm} header="Confirm">
        <div className="p-1">Are you sure?</div>
        <div>
          <ButtonPrimary onClick={handleDeleteConfirm} text="confirm" />
          <ButtonSecondary onClick={handleDeleteCancel} text="cancel" />
        </div>
      </ModalDialog>

      <PermissionNodeGroupModal
        target={target}
        nodeID={nodeID}
        allowAdd={roleOrgNodeGroup.accessCreate}
        allowDelete={roleOrgNodeGroup.accessDelete}
        onClose={handleClose}
        onClosed={handleClosed}
      />
      <BreadcrumbView Icon={IconGroup} text="Group permissions">
        <CardFullHeightScrollY title="Group permissions" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListNodeGroup} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="groupName" header="Group" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRemove onClick={() => handleDelete(row)} show={roleOrgNodeGroup.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
